import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BreadCrumb from "../components/breadCrumb";
import CheckBox from "../components/common/CheckBox";
import ComboBoxData from "../components/common/ComboBoxData";
import ComboBoxDataMulti from "../components/common/ComboBoxDataMulti";
import { NumericBox } from "../components/common/NumericBox";
import PageContent from "../components/pageContent";
import ProductBreadCrumb from "../components/products/ProductBreadCrumb";
import TopBarWithBreadCrumb from "../components/TopBarWithBreadCrumb";
import { apiGetAllBasesByProduct } from "../services/BasesService";
import { apiGetAllColorsForSampleCard } from "../services/ColorsService";
import { apiGetAllProducts } from "../services/ProductsService";
import { apiGetSampleCardsForProduct } from "../services/SampleCardsService";
import { MultiSelect } from "react-multi-select-component";

import './KopirovaniRecepturReportPage.css';
import { TextBox } from "../components/common/TextBox";
import { apiCreateReceiptsCopyJob, apiLoadReceiptsCopyJob, apiProcessReceiptsCopyJob } from "../services/ReceiptsService";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const KopirovaniRecepturReportPage = () => {

    const { t } = useTranslation(undefined, { keyPrefix: 'CopyReceiptsReportPage' });
    const [jobIsRunning, setJobIsRunning] = useState(false);
    const jobIsRunningRef = useRef(jobIsRunning);
    jobIsRunningRef.current = jobIsRunning;
    let initJobItemsData: any;
    const [jobItemsData, setJobItemsData] = useState(initJobItemsData);
    const [itemDetailsById, setItemDetailsById] = useState<any>({});
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const jobIdentifierFromUrl = params.get('jobIdentifier') || '';
    const [jobIdentifierError, setJobIdentifierError] = useState(false);

    useEffect(() => {
        if (jobIdentifierFromUrl && jobIdentifierFromUrl.length > 0) {
            loadData();
        }
        else {
            setJobIdentifierError(true);
        }
    }, []);

    const loadData = async () => {

        // popis receptur (vyrobek, vzorkovnice, odstin, baze) se nacita jen jednou, behem pollingu se uz nemeni
        var jobData = await loadJobItemsData(true);
        var notCompletedItems = jobData.items.filter(a => a.status == "Queued");

        if (notCompletedItems && notCompletedItems.length > 0) {
            apiProcessReceiptsCopyJob(jobIdentifierFromUrl);
            setJobIsRunning(true);
            await autoLoadItemsInInterval(true);
        }
    }

    const loadJobItemsData = async (includeDetails: boolean = false) => {
        var jobData = await apiLoadReceiptsCopyJob(jobIdentifierFromUrl, includeDetails);
        setJobItemsData(jobData.data);

        if (includeDetails && jobData.data && jobData.data.details) {
            const detailsMap: any = {};
            jobData.data.details.forEach((detail: any) => { detailsMap[detail.id] = detail; });
            setItemDetailsById(detailsMap);
        }

        return jobData.data;
    }

    const autoLoadItemsInInterval = async (jobIsRunningParam) => {

        let jobRunning = jobIsRunningRef.current || jobIsRunningParam;

        if (jobRunning) {

            let jobData = await loadJobItemsData();
            var notCompletedItems = jobData.items.filter(a => a.status == "Queued");

            if (notCompletedItems && notCompletedItems.length > 0) {
                setTimeout(() => autoLoadItemsInInterval(false), 1000);
            }
            else {
                setJobIsRunning(false);
            }
        }
    }

    const statusLabel = (jobItem: any) => jobItem.completed
        ? t('StatusCompleted')
        : (jobIsRunning ? t('StatusQueued') : t('StatusNotProcessed'));

    const totalItems = jobItemsData?.totalItems || 0;
    const completedItems = jobItemsData?.completed || 0;
    const progressPercent = totalItems > 0 ? Math.round(100 * completedItems / totalItems) : 0;

    return <>
        <PageContent>
            <>
                <TopBarWithBreadCrumb
                    contextLevel={"Receptury"}
                    pageLevel="Receptury"
                />

                <div className="row" style={{ padding: '20px' }}>
                    <div className="col-12" >
                        <div className={`card`}>
                            <div className="card-header">
                                <h3 className="copyingSectionHeader">{t('CopyingReceipts')} ({t('Job')} {jobIdentifierFromUrl})</h3>
                            </div>
                            <div className="card-body" >

                                {jobIdentifierError && <span>{t('JobCannotBeRecognized')}</span>}
                                {!jobIdentifierError && <div>
                                    <div className="card-body" >
                                        <div>{t('JobStatus')} {jobIsRunning ? 'Running' : 'Not running'}</div>
                                        <div>{t('TotalReceipts')} {totalItems}</div>
                                        <div>{t('AlreadyCopied')} {completedItems}</div>
                                        <div>{t('RemainingReceipts')} {jobItemsData?.notCompleted || 0}</div>
                                    </div>

                                    <div className="progress copy-progress-bar">
                                        <div
                                            className="progress-bar"
                                            role="progressbar"
                                            style={{ width: `${progressPercent}%` }}
                                            aria-valuenow={progressPercent}
                                            aria-valuemin={0}
                                            aria-valuemax={100}
                                        >
                                            {progressPercent}%
                                        </div>
                                    </div>

                                    <div className="copy-progress-table-wrapper">
                                        <table className="table table-sm copy-progress-table">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>{t('SourceProduct')}</th>
                                                    <th>{t('TargetProduct')}</th>
                                                    <th>{t('SampleBook')}</th>
                                                    <th>{t('Color')}</th>
                                                    <th>{t('Basis')}</th>
                                                    <th>{t('Status')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {jobItemsData && jobItemsData.items.map((jobItem: any, index: number) => {
                                                    const detail = itemDetailsById[jobItem.id];

                                                    return <tr key={jobItem.id} className={jobItem.completed ? 'copy-progress-row-done' : ''}>
                                                        <td>{index + 1} / {totalItems}</td>
                                                        <td>{detail?.sourceProduct || (detail ? `#${detail.receiptId}` : '')}</td>
                                                        <td>{detail?.targetProduct}</td>
                                                        <td>{detail?.sampleCard}</td>
                                                        <td>{detail?.color}</td>
                                                        <td>{detail?.basis}</td>
                                                        <td>{statusLabel(jobItem)}</td>
                                                    </tr>
                                                })}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>}
                            </div>
                        </div>
                    </div>
                </div>
            </>
        </PageContent>
    </>
}

export default KopirovaniRecepturReportPage;